
import {  useQuery } from "react-query"
import DataService from "../../../config/DataServices"
const { getRequest } = DataService();

export const useUserUpgradeHistory = ({ page, size,type }) => {

    return useQuery({
        queryKey: ['upgrade-history',page, size,type],
        queryFn: () => {
            return getRequest(`user/auth/topup-history?page=${page}&size=${size}&type=${type}`)
        },
    })
}
export const useUserLevelDetails = () => {

    return useQuery({
        queryKey: ['level-details'],
        queryFn: () => {
            return getRequest(`user/auth/level-details`)
        },
    })
}

export const useUserSingleLevelDetails = ({level,page, size,searchText,type}) => {

    return useQuery({
        queryKey: ['single-details',level,page, size,searchText],
        queryFn: () => {
            return getRequest(`user/auth/getrecivedamount?level=${level}&page=${page}&size=${size}&search=${searchText}&type=${type}`)
        },
    })
}


export const useUserLevelHistory = () => {

    return useQuery({
        queryKey: ['level-history'],
        queryFn: () => {
            return getRequest(`user/auth/getUpgradeHistory`)
        },
    })
}                   
export const useUserMissedHistory = ({level,searchText,page, size,}) => {

    return useQuery({
        queryKey: ['missed-history',level,searchText,page, size,],
        queryFn: () => {
            return getRequest(`user/auth/getuser-missed?level=${level}&search=${searchText}&page=${page}&size=${size}`)
        },
    })
}


export const useUserOverAllUpgradeBalance = () => {

    return useQuery({
        queryKey: ['overall-balance'],
        queryFn: () => {
            return getRequest(`user/auth/upgradeBal`)
        },
    })
}


export const useUserPendingHistory = ({level,page,size,searchText}) => {

    return useQuery({
        queryKey: ['pending-history',level,page,size,searchText],
        queryFn: () => {
            return getRequest(`user/auth/pendingReferHis?level=${level}&page=${page}&size=${size}&search=${searchText}`)
        },
    })
}


export const useGetAllMembers = ({page,size,levels,searchText}) => {

    return useQuery({
        queryKey: ['all-member',page,size,levels,searchText],
        queryFn: () => {
            return getRequest(`user/auth/getlevels?page=${page}&size=${size}&levels=${levels}&search=${searchText}`)
        },
    })
}

export const useGetTotalActivateIncome = ({level}) => {

    return useQuery({
        queryKey: ['active-icCome',level],
        queryFn: () => {
            return getRequest(`user/auth/getTotalActivateIncome?level=${level}`)
        },
    })
}


export const useGetTopUpAmount = () => {

    return useQuery({
        queryKey: ['topup-amount'],
        queryFn: () => {
            return getRequest(`user/auth/getpay`)
        },
    })
}
